import { createContext } from "react";

import type { AlertColor } from "@mui/material";

export interface NotificationState {
  open: boolean;
  message: string;
  severity: AlertColor;
  autoHideDuration?: number;
}

export interface NotificationContextType {
  showNotification: (
    message: string,
    severity?: AlertColor,
    autoHideDuration?: number,
  ) => void;
  showError: (message: string) => void;
  showSuccess: (message: string) => void;
  showWarning: (message: string) => void;
  showInfo: (message: string) => void;
  hideNotification: () => void;
}

export const NotificationContext = createContext<
  NotificationContextType | undefined
>(undefined);
